module.exports = __webpack_public_path__ + "static/media/barber2.7b343fcf.jpg";